/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamItemLevelsQueryResponse,
  GetApiV1ExamItemLevels401,
  GetApiV1ExamItemLevels500,
} from "../../types/examQuestionLibraryController/GetApiV1ExamExamItemLevels.ts";

function getGetApiV1ExamExamItemLevelsUrl() {
  const res = { method: "GET", url: `/api/v1/exam/exam-item-levels` as const };
  return res;
}

/**
 * @description Retorna todos os níveis de questão disponíveis para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Listar níveis de questão para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/exam-item-levels}
 */
export async function getApiV1ExamExamItemLevels(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamItemLevelsQueryResponse,
    ResponseErrorConfig<GetApiV1ExamItemLevels401 | GetApiV1ExamItemLevels500>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamExamItemLevelsUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
